import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Card, CardContent, Typography, useTheme } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useGlassmorphismStyles } from '../../shared/hooks/useGlassmorphismStyles';
import { startPurchase } from '../redux/purchaseSlice';
export const ProductItem = ({ product }) => {
    const dispatch = useDispatch();
    const handlePurchase = () => {
        dispatch(startPurchase());
        const storeProduct = CdvPurchase.store.get(product.id, CdvPurchase.Platform.ANDROID);
        if (storeProduct) {
            storeProduct.getOffer().order();
        }
    };
    const theme = useTheme();
    const glassStyles = useGlassmorphismStyles({
        opacity: theme.palette.mode === 'dark' ? 0.1 : 0.4,
    });
    return (_jsx(Card, Object.assign({ sx: glassStyles }, { children: _jsxs(CardContent, { children: [_jsx(Typography, Object.assign({ variant: "h5" }, { children: product.title })), _jsx(Typography, { children: product.description }), _jsx(Typography, { children: product.price }), product.canPurchase && (_jsx(Button, Object.assign({ variant: "contained", onClick: handlePurchase }, { children: "Buy Now" })))] }) })));
};
